module.exports = __webpack_public_path__ + "weathericons-regular-webfont.b2233bc1525939550405.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/weather-icons/font/weathericons-regular-webfont.svg
// module id = ../../../../weather-icons/font/weathericons-regular-webfont.svg
// module chunks = styles